<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <div class="row">
        <div class="col-6">
          نام و نام خانوادگی:
          {{ formItems.full_name ? formItems.full_name : "-" }}
        </div>
        <div class="col-6">
          زمان ثبت سفارش:
          {{
            formItems.created_at
              ? $getJalaliDateTime(formItems.created_at)
              : "-"
          }}
        </div>
      </div>
<!--      <div class="row">-->
<!--        <div class="col-6">-->
<!--          استان: {{ formItems.province ? formItems.province : "-" }}-->
<!--        </div>-->
<!--        <div class="col-6">-->
<!--          شهر: {{ formItems.city ? formItems.city : "-" }}-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row">-->
<!--        <div class="col-6">-->
<!--          ادرس: {{ formItems.address ? formItems.address : "-" }}-->
<!--        </div>-->
<!--        <div class="col-6">-->
<!--          کدپستی: {{ formItems.postal_code ? formItems.postal_code : "-" }}-->
<!--        </div>-->
<!--      </div>-->
      <div class="row">
        <div class="col-6">
          تلفن همراه: {{ formItems.mobile ? formItems.mobile : "-" }}
        </div>
        <div class="col-6">
          ایمیل: {{ formItems.email ? formItems.email : "-" }}
        </div>
      </div>
      <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>نام</th>
            <th>قیمت واحد</th>
            <th>مبلغ کل</th>
            <th>مبلغ تخفیف</th>
            <th>مبلغ کل پس از تخفیف</th>
            <!-- <th>قیمت با تخفیف</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in formItems.items" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              {{ item.product_name }} <br />
              <small>{{ item.product_price_name }}</small>
            </td>
            <td>{{ $thousandSeprator(item.price) }}</td>
            <td>{{ $thousandSeprator(item.price) }}</td>
            <td>{{ $thousandSeprator(item.payable_price - item.price) }}</td>
            <td>{{ $thousandSeprator(item.payable_price) }}</td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: left">جمع کل</td>
            <td>{{ $thousandSeprator(formItems.total) }}</td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: left">تخفیف حراجی</td>
            <td>
              {{
                formItems.discount ? $thousandSeprator(formItems.discount) : "-"
              }}
            </td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: left">سایر تخفیف ها</td>
            <td>
              {{
                formItems.coupon_price
                  ? $thousandSeprator(formItems.coupon_price)
                  : "-"
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td style="width:71%;text-align: left">
              پرداخت شده توسط کیف پول
            </td>
            <td>{{ $thousandSeprator(formItems.wallet_payed) }}</td>
          </tr>
          <tr>
            <td style="text-align: left">پرداخت آنلاین</td>
            <td>{{ $thousandSeprator(formItems.online_payed) }}</td>
          </tr>
          <tr>
            <td style="text-align: left">درگاه پرداخت</td>
            <td>{{ formItems.paymethod ? formItems.paymethod.title : "-" }}</td>
          </tr>
        </tbody>
      </table>
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-bootbutton
              v-if="formItems.paymethod && formItems.paymethod.method == 2"
              type="primary mr-2 ml-2"
              title="نمایش فیش"
              icon="fa fa-images"
              btn-width="200px"
              @click.native="showFullSizeImage"
            />
            <bita-bootbutton
              v-if="formItems.payment_status != 1"
              type="primary mr-2 ml-2"
              title="تایید پرداخت موفق"
              icon="fa fa-check"
              btn-width="200px"
              @click.native="paymentSuccessfully"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
<!--       <bita-bootbutton
        v-if="$acl.can('edit', 'orders')"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      /> -->
<!--       <bita-bootbutton
        class="mr-2"
        type="primary"
        title="چاپ لیبل پست"
        icon="fa fa-print"
        btn-width="150px"
        @click.native="labelPrint()"
      />
      <bita-bootbutton
        class="mr-2"
        type="primary"
        title="چاپ فاکتور"
        icon="fa fa-print"
        btn-width="150px"
        @click.native="printInvoice()"
      /> -->
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import { orderApi } from "@/api/apiManagement";

export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    settings: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      formItems: {},
      dataForm: {},
      statuses: [],
    };
  },
  computed: {},
  mounted() {
    this.getStatuses();
  },
  methods: {
    setInitialData(_data) {
      this.isLoading = true;
      // this.formItems = _data;
      orderApi
        .findOrder(_data.id)
        .then((res) => {
          this.formItems = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getStatuses() {
      orderApi.getStatuses().then(({ data }) => (this.statuses = data));
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", {
            form_data: this.formItems,
            id: this.formItems.id,
          });
        }
      });
    },
    printInvoice() {
      let baseUrl = process.env.VUE_APP_API_BASEPOINT;
      window.open(`orders/${this.formItems.id}/print`, "_blank");
    },
    printTemplate() {
      if (this.formItems) {
        let cities = `${this.formItems.province}، ${this.formItems.city}`;
        let address = this.formItems.address ? this.formItems.address : "-";
        let fullName = this.formItems.full_name
          ? this.formItems.full_name
          : "-";
        let tel = this.formItems.mobile ? this.formItems.mobile : "-";
        let postalcode = this.formItems.postal_code
          ? this.formItems.postal_code
          : "-";
        let settings = this.settings;
        var template = "";
        console.log();
        var template = `
          <style>
              body {
                background-color: ${settings.post_label_color} !important;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
          }
            *{line-height: 2px;}
          </style>
<div style=" display:flex;background-color: ${
          settings.post_label_color
        } !important;
  min-height:100%;">
          <div style="width: 80%; display: block;margin:auto; background-color: #fff; border-radius: 10px;padding: 50px">
            <div style="direction:rtl; text-align=right;line-height: 20px; font-size:15px; font-weigth: bold; font-family: iranyekan">
                <div class="sender">
                  <h2 style="padding: 5px 0; margin: 5px 0;line-height:10px; display:inline-block">گیرنده /</h2>
                  <img src="${
                    settings.post_label_logo
                  }" width="200" height="75" style="display:inline-block; float: left"/>
                   <div> <h3 style="display:inline-block">نام:</h3> <h4 style="display:inline-block">${fullName}</h4></div>
                    <div><h3 style="display:inline-block">استان و شهر:</h3> <h4 style="display:inline-block">${cities}</h4></div>
                    <div><h3 style="display:inline-block">آدرس:</h3> <h4 style="display:inline-block">${address}</h4></div>
                   <div><h3 style="display:inline-block">کدپستی:</h3> <h4 style="display:inline-block">${postalcode}</h4></div>
                   <div><h3 style="display:inline-block">تلفن:</h3> <h4 style="display:inline-block">${tel}</h4></div>
                  <h5></h5>
                   </div>
                   <div>
                                <h2 style="padding: 5px 0; margin: 5px 0;line-height:10px;">فرستنده / ${settings.title}</h2>
                                <h3 style="line-height: 20px;">${
                                  settings.address ? settings.address : "-"
                                } ، کدپستی ${
          settings.postal_code ? settings.postal_code : "-"
        }  - تلفن: ${settings.tel ? settings.tel : "-"} </h3>
                                <h3 style="line-height: 20px;">${
                                  settings.label_footer
                                    ? settings.label_footer
                                    : ""
                                } </h3>
              </div>
             </div>
            </div>
          </div>
        `;

        return template;
      }
    },
    reset() {
      this.$refs.form.reset();

      this.formItems = {};
    },

    labelPrint() {
      this.isLoading = true;

      $("<iframe>", {
        name: "myiframe",
        class: "printFrame",
      })
        .appendTo("body")
        .contents()
        .find("body")
        .append(this.printTemplate());

      setTimeout(() => {
        this.isLoading = false;
        window.frames["myiframe"].focus();
        window.frames["myiframe"].print();
      }, 1000);
      setTimeout(() => {
        $(".printFrame").remove();
      }, 2000);
    },

    showFullSizeImage() {
      var url = this.formItems.receipt_file_url;
      window.open(url, "receipt image");
    },

    clearKendos(_refs) {
      for (let ref of _refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
    },
    onCloseModal(e) {
      this.formItems = {};
      let dropDowns = ["statusDropDown"];
      this.clearKendos(dropDowns);
      this.reset();
    },
    paymentSuccessfully(e) {
      this.$emit("on-update", this.formItems);
    },
  },
};
</script>
